import { __assign, __rest } from "tslib";
import React from 'react';
import MuiBox from '@mui/material/Box';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
var getGapDirection = function (props) {
    if (props.display !== 'flex' && props.display !== 'inline-flex') {
        return 'margin-top';
    }
    switch (props.flexDirection) {
        case 'column-reverse':
            return 'margin-bottom';
        case 'row':
            return 'margin-left';
        case 'row-reverse':
            return 'margin-right';
        case 'column':
        default:
            return 'margin-left';
    }
};
var getGapOpposingDirection = function (direction) {
    switch (direction) {
        case 'margin-top':
            return 'margin-bottom';
        case 'margin-bottom':
            return 'margin-top';
        case 'margin-left':
            return 'margin-right';
        case 'margin-right':
            return 'margin-left';
        default:
            return 'invalid';
    }
};
var getGapSize = function (gap, theme) {
    if (typeof gap === 'number') {
        return theme.spacing(gap);
    }
    switch (gap) {
        case 'xs':
            return theme.spacing(1);
        case 'sm':
            return theme.spacing(2);
        case 'md':
            return theme.spacing(3);
        case 'lg':
            return theme.spacing(4);
        case 'xl':
            return theme.spacing(5);
        default:
            return gap;
    }
};
var useStyles = makeStyles(function (theme) { return ({
    root: function (props) {
        var _a, _b;
        if (!props.gap) {
            return {};
        }
        var gapDirection = getGapDirection(props);
        var gapSize = getGapSize(props.gap, theme);
        return {
            '&& > *': (_a = {},
                _a[getGapOpposingDirection(gapDirection)] = 0,
                _a),
            '&& > * + *': (_b = {},
                _b[gapDirection] = gapSize,
                _b),
        };
    },
}); });
/**
 * Extended from Material UI's core Box component, this component adds
 * the `gap` prop, which uses CSS rules to add space between child elements.
 * @public
 */
var Box = React.forwardRef(function (_a, ref) {
    var gap = _a.gap, rest = __rest(_a, ["gap"]);
    var classes = useStyles(__assign({ gap: gap }, rest));
    return (React.createElement(MuiBox, __assign({ ref: ref }, rest, { className: clsx(classes.root, rest.className) })));
});
// @ts-expect-error https://material-ui.com/guides/composition/#wrapping-components
Box.muiName = MuiBox.muiName;
export default Box;
//# sourceMappingURL=Box.js.map